import { App } from './App';
import './styles.scss';

export default {
  App
}
